import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Calendar, User } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

// Animation constants
const TITLE_INITIAL = { opacity: 0, y: 30 };
const TITLE_ANIMATE = { opacity: 1, y: 0 };
const TITLE_TRANSITION = { duration: 0.6 };

const BlogPostHeader = ({ post }) => {
  const { t } = useLanguage();

  return (
    <div className="relative h-96 overflow-hidden">
      <img
        src={post.image}
        alt={post.title}
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/50 via-slate-900/70 to-slate-900" />
      
      {/* Back to Blog Button - Positioned below fixed Navbar */}
      <div className="absolute top-24 left-4 md:left-8 z-20">
        <Link
          to="/#blog"
          className="flex items-center space-x-2 px-4 py-2 rounded-lg bg-white/10 backdrop-blur-md border border-white/20 hover:bg-white/20 transition-all group"
        >
          <ArrowLeft className="w-4 h-4 text-white group-hover:-translate-x-1 transition-transform" />
          <span className="text-white font-medium">{t.blogPost.backToBlog}</span>
        </Link>
      </div>

      {/* Title Overlay */}
      <div className="absolute bottom-0 left-0 right-0 p-8 md:p-16">
        <div className="max-w-4xl mx-auto">
          <motion.div
            initial={TITLE_INITIAL}
            animate={TITLE_ANIMATE}
            transition={TITLE_TRANSITION}
          >
            <div className="inline-block px-4 py-1 rounded-full bg-orange-500/20 border border-orange-500/30 mb-4">
              <span className="text-orange-300 text-sm font-medium">{post.category}</span>
            </div>
            
            <h1 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight">
              {post.title}
            </h1>

            <div className="flex flex-wrap items-center gap-4 text-gray-300">
              <div className="flex items-center space-x-2">
                <Calendar className="w-4 h-4" />
                <span className="text-sm">{post.date}</span>
              </div>
              <div className="flex items-center space-x-2">
                <User className="w-4 h-4" />
                <span className="text-sm">{post.author}</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default BlogPostHeader;
